import Navbar from "./components/Navbar";
import Heading from "./components/Heading";
import Main from "./components/Main";
import Create from "./components/Create";

function App() {
  return (
    <>
      <Navbar />
      <Heading />
      <Main />
      <Create />
    </>
  );
}

export default App;
